import React, {useState} from "react";
import Switch from '@mui/material/Switch';
import Typography from "@mui/material/Typography";
import { Grid } from "../../UI/Grid";
import { MainLayout } from "../../layout/MainLayout";
import { RequestChangeButton } from "../../components/RequestChangeButton";
import { IntegrationTable } from "../../components/IntegrationTable";
import useAuth from "../login/AuthContext";
import { ModalProvider } from "../../contexts/ModalContext";
import { CreateMappingButton } from "../../components/CreateMappingButton";
import { ForceImportButton } from "../../components/ForceImportButton";
import { IntegrationProvider } from "../../components/IntegrationTable/IntegrationProvider";
import { EntrataIntegrationProvider } from "../../components/IntegrationTable/EntrataIntegrationProvider";
import { IntegrationEntrataExtraInfo } from "../../components/IntegrationTable/IntegrationEntrataExtraInfo";
import { useSelectedNetworkImportTypes } from "../../hooks/useSelectedNetworkImportType";
import {ImportMigrationButton} from "../../components/ImportMigrationButton";
import {AccDebugButton} from "../../components/AccDebugButton";
// import {AccEnableImportSwitch} from "../../components/AccEnableImportSwitch";

const INTEGRATION_HELP_CONTENT =
  "RoomSync determines which residents to import from your management system based on this table.";

export const IntegrationsPage = () => {
  const [ showArchived, setShowArchived ] = useState<boolean>(false);
  const [ showAll, setShowAll ] = useState<boolean>(false);
  const { isSuperAdmin } = useAuth();
  const { isEntrata, isAcc, isKinetic, getImportType } = useSelectedNetworkImportTypes();
  const handleSetArchivedTogglChange = (_: any, checked: boolean) =>setShowArchived(checked);
  const handleSetAllTogglChange = (_: any, checked: boolean) =>setShowAll(checked);

  return (
    <IntegrationProvider>
      <EntrataIntegrationProvider>
        <MainLayout
          headerMt={2}
          title="Integrations"
          titleHelpText={INTEGRATION_HELP_CONTENT}
          endAdornment={
            isSuperAdmin() ? (
              <>
              <Grid item container spacing={2}>
                <Grid item>
                  {
                    isEntrata && <Typography> Show Archived
                    <Switch value={showArchived} onChange={handleSetArchivedTogglChange}/>
                  </Typography>
                  }
                   {
                    !isEntrata && <Typography> Show All
                    <Switch value={showAll} onChange={handleSetAllTogglChange}/>
                  </Typography>
                  }
                </Grid>
                <Grid item>
                  <ModalProvider>
                    <ImportMigrationButton/>
                  </ModalProvider>
                </Grid>
                <Grid item>
                  <ModalProvider>
                    <CreateMappingButton />
                  </ModalProvider>
                </Grid>
              </Grid>
              <Grid item container spacing={2} justifyContent="flex-end">
                {/* {isAcc && (
                  <Grid item mr={2}>
                    <AccEnableImportSwitch />
                  </Grid>
                )} */}
                
                <Grid item mr={4}>
                  {(isAcc || isKinetic) && getImportType != null &&  <ForceImportButton importType={getImportType()}/>}
                </Grid>
                <Grid item>
                  
                {isAcc &&  <ModalProvider>
                  <AccDebugButton />
                </ModalProvider>}
                </Grid>
              </Grid>
              </>
            ) : (
              <>
              <Grid item container spacing={2} justify="flex-end">
                <Grid item>
                  {
                    isEntrata && <Typography> Show Archived
                    <Switch value={showArchived} onChange={handleSetArchivedTogglChange}/>
                  </Typography>
                  }
                   {
                    !isEntrata && <Typography> Show All
                    <Switch value={showAll} onChange={handleSetAllTogglChange}/>
                  </Typography>
                  }
                </Grid>
              </Grid>
              <Grid item container spacing={2} justify="flex-end">
                {/* {isAcc && (
                  <Grid item mr={2}>
                    <AccEnableImportSwitch disabled label="Enabled Import"/>
                  </Grid>
                )} */}
              </Grid>
              </>
            )
          }
        >
          {(isEntrata ? <IntegrationEntrataExtraInfo /> : null)}
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <IntegrationTable showArchived={showArchived} showAll={showAll} />
            </Grid>
            <Grid item xs={12}>
              <RequestChangeButton
                url="https://www.roomsync.com/help/contact-us"
              />
            </Grid>
          </Grid>
        </MainLayout>
      </EntrataIntegrationProvider>
    </IntegrationProvider>
  );
};